import RequestAbstract from "../abstract";

export default class PaymentGateways extends RequestAbstract {
    data;
    constructor(data) {
        super(data);
        this.data = data;
        this.link = "api/payment-gateways";
    }
}
